export function Footer() {
  return (
    <footer className="border-t border-gray-200 bg-white py-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="font-bold mb-4 text-gray-900">ourteam</h3>
            <p className="text-sm text-gray-600">
              Connecting talent with opportunities in Asia
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-3 text-gray-900">For Employers</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button className="text-gray-600 hover:text-gray-900">
                  Find Talent
                </button>
              </li>
              <li>
                <button className="text-gray-600 hover:text-gray-900">
                  Pricing
                </button>
              </li>
              <li>
                <button className="text-gray-600 hover:text-gray-900">
                  Resources
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-3 text-gray-900">
              For Job Seekers
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button className="text-gray-600 hover:text-gray-900">
                  Find Jobs
                </button>
              </li>
              <li>
                <button className="text-gray-600 hover:text-gray-900">
                  Career Resources
                </button>
              </li>
              <li>
                <button className="text-gray-600 hover:text-gray-900">
                  Success Stories
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-3 text-gray-900">Company</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button className="text-gray-600 hover:text-gray-900">
                  About Us
                </button>
              </li>
              <li>
                <button className="text-gray-600 hover:text-gray-900">
                  Blog
                </button>
              </li>
              <li>
                <button className="text-gray-600 hover:text-gray-900">
                  Contact
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200 text-center text-sm text-gray-600">
          © 2025 Ourteam. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
